import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPresentationStyle0 = cosmosIconCss;

const CosmosIconPresentation$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPresentation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bf39351facb312819aa05714818d15a044ac1352', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bb873c72d4363c9c10b15f762770c6b0bc1107ec', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bc64f0428d76631e54d9fe6322453c80ed3fcc0e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.208 15.052 5.5 2.538a.5.5 0 0 1 .246.663l-.209.454a.5.5 0 0 1-.663.246l-4.871-2.25a.5.5 0 0 0-.42 0l-4.867 2.248a.5.5 0 0 1-.663-.244l-.21-.454a.5.5 0 0 1 .243-.663l5.495-2.538a.5.5 0 0 1 .419 0ZM18.5 3a.5.5 0 0 1 .492.41L19 3.5v10a.5.5 0 0 1-.41.492L18.5 14h-15a.5.5 0 0 1-.492-.41L3 13.5v-10a.5.5 0 0 1 .41-.492L3.5 3h15Zm-1 1.5h-13v8h13v-8Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPresentationStyle0; }
}, [1, "cosmos-icon-presentation", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-presentation"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-presentation":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPresentation$1);
            }
            break;
    } });
}

const CosmosIconPresentation = CosmosIconPresentation$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPresentation, defineCustomElement };
